var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2468_1650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 6.41667H0V1.75C0 1.28587 0.184374 0.840752 0.512563 0.512563C0.840752 0.184374 1.28587 0 1.75 0L6.41667 0V6.41667ZM1.16667 5.25H5.25V1.16667H1.75C1.59529 1.16667 1.44692 1.22812 1.33752 1.33752C1.22812 1.44692 1.16667 1.59529 1.16667 1.75V5.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 6.41667H7.58325V0H12.2499C12.714 0 13.1592 0.184374 13.4873 0.512563C13.8155 0.840752 13.9999 1.28587 13.9999 1.75V6.41667ZM8.74992 5.25H12.8332V1.75C12.8332 1.59529 12.7718 1.44692 12.6624 1.33752C12.553 1.22812 12.4046 1.16667 12.2499 1.16667H8.74992V5.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 14H1.75C1.28587 14 0.840752 13.8157 0.512563 13.4875C0.184374 13.1593 0 12.7142 0 12.25L0 7.58337H6.41667V14ZM1.16667 8.75004V12.25C1.16667 12.4047 1.22812 12.5531 1.33752 12.6625C1.44692 12.7719 1.59529 12.8334 1.75 12.8334H5.25V8.75004H1.16667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 14H7.58325V7.58337H13.9999V12.25C13.9999 12.7142 13.8155 13.1593 13.4873 13.4875C13.1592 13.8157 12.714 14 12.2499 14ZM8.74992 12.8334H12.2499C12.4046 12.8334 12.553 12.7719 12.6624 12.6625C12.7718 12.5531 12.8332 12.4047 12.8332 12.25V8.75004H8.74992V12.8334Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2468_1650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.5d2d962964f66aa919507d370e9af586.svg";
export { ForwardRef as ReactComponent };